import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { UserSession } from '../models/usersession';

@Injectable()

export class UserSessionService {

  session = new UserSession();
  sessionStorageSessionKey: string;
  filterArr: any[];
  menu: any = []


  constructor() {
    this.sessionStorageSessionKey = 'eGramam-' + environment.apiBaseUrl + '-AuthData';
  }

  create(session) {// jshint ignore:line
    this.setsessionStorageProperties(session);
  }

  destroy() {// jshint ignore:line
    this.setsessionStorageProperties(new UserSession());
    sessionStorage.removeItem('role');
    sessionStorage.removeItem("bulkstopid");
    sessionStorage.removeItem("profileid");
    sessionStorage.removeItem("FetchId");
    sessionStorage.removeItem('excel_value');
    sessionStorage.removeItem('filename');
    sessionStorage.removeItem("bulkstopid");
    sessionStorage.removeItem('cardNo')

    sessionStorage.clear();
  }

  setsessionStorageProperties(session: any) {// jshint ignore:line
    sessionStorage.setItem(this.sessionStorageSessionKey, JSON.stringify(session));
  }

  getSessionStorageWithKey(key: any) {// jshint ignore:line
    return sessionStorage.getItem(key);
  }

  setsessionStorageWithKey(key: any, session: any) {// jshint ignore:line
    sessionStorage.setItem(key, JSON.stringify(session));
  }

  isDynamicPassword() {
    const jsonData = sessionStorage.getItem(this.sessionStorageSessionKey);
    return jsonData == null ? '' : JSON.parse(jsonData);
  }

  getPageUrl(key: any) {
    this.filterArr = [];
    const menu = JSON.parse(this.getSessionStorageWithKey('menucontrols'))
    const filterItems = menu.map(e => {
      e.submenu.forEach(element => {
        this.filterArr.push(element);
      });
    });
    const output = this.filterArr.find(e => {
      return e.path === key;
    })
    return output.controlAccess;
  }

  cardNumber() {
    const jsonData = sessionStorage.getItem(this.sessionStorageSessionKey);
    return jsonData == null ? '' : JSON.parse(jsonData).cardNumber;
  }

  trackingNo() {
    const jsonData = sessionStorage.getItem(this.sessionStorageSessionKey);
    return jsonData == null ? '' : JSON.parse(jsonData).trackingNo;
  }

  cvvNo() {
    const jsonData = sessionStorage.getItem(this.sessionStorageSessionKey);
    return jsonData == null ? '' : JSON.parse(jsonData).cvvNo;
  }

  expiryDate() {
    const jsonData = sessionStorage.getItem(this.sessionStorageSessionKey);
    return jsonData == null ? '' : JSON.parse(jsonData).expiryDate;
  }

  cardID() {
    const jsonData = sessionStorage.getItem(this.sessionStorageSessionKey);
    return jsonData == null ? '' : JSON.parse(jsonData).cardID;
  }
  profileType() {
    const jsonData = sessionStorage.getItem(this.sessionStorageSessionKey);
    return jsonData == null ? '' : JSON.parse(jsonData).profileType;
  }
  clientId() {
    const jsonData = sessionStorage.getItem(this.sessionStorageSessionKey);
    return jsonData == null ? '' : JSON.parse(jsonData).clientId;
  }
  cardholderName() {
    const jsonData = sessionStorage.getItem(this.sessionStorageSessionKey);
    return jsonData == null ? '' : JSON.parse(jsonData).cardholderName;
  }
  profileID() {
    const jsonData = sessionStorage.getItem(this.sessionStorageSessionKey);
    return jsonData == null ? '' : JSON.parse(jsonData).profileId;
  }

  authToken() {
    const jsonData = sessionStorage.getItem(this.sessionStorageSessionKey);
    return jsonData == null ? '' : JSON.parse(jsonData).authToken;
  }
  mobile() {
    const jsonData = sessionStorage.getItem(this.sessionStorageSessionKey);
    return jsonData == null ? '' : JSON.parse(jsonData).mobile;
  }



}

